<div class="bpx-dialog bpx-dialog--wide user-dialog">
  <h2 mat-dialog-title>Add User</h2>
  <mat-dialog-content>
    <div class="user-dialog__grid">
      <div class="bpx-control">
        <span class="bpx-control__label" id="add-user-first-name-label">First Name</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.first_name" required aria-labelledby="add-user-first-name-label" />
        </mat-form-field>
      </div>
      <div class="bpx-control">
        <span class="bpx-control__label" id="add-user-last-name-label">Last Name</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.last_name" required aria-labelledby="add-user-last-name-label" />
        </mat-form-field>
      </div>
      <div class="bpx-control">
        <span class="bpx-control__label" id="add-user-email-label">Email</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput type="email" [(ngModel)]="formData.email" required aria-labelledby="add-user-email-label" />
        </mat-form-field>
      </div>
      <div class="bpx-control">
        <span class="bpx-control__label" id="add-user-employee-id-label">Employee ID</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
          <input matInput [(ngModel)]="formData.employee_id" required aria-labelledby="add-user-employee-id-label" />
        </mat-form-field>
      </div>
      <mat-checkbox class="user-dialog__check" [(ngModel)]="formData.super_user">Is super user</mat-checkbox>
    </div>
    <div class="bpx-error" *ngIf="showErrors && getValidationMessage()" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ getValidationMessage() }}</span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="user-dialog__actions">
    <button matRipple type="button" class="bpx-btn bpx-btn--primary" (click)="submit()">Add</button>
    <button matRipple type="button" class="bpx-btn" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
